import React from 'react';
import { motion } from 'framer-motion';

export const SkeletonProfile = () => (
  <div className="glass" style={{ borderRadius: '1.5rem', overflow: 'hidden' }}>
    <div style={{ width: '100%', aspectRatio: '1/1', background: 'rgba(255,255,255,0.05)', position: 'relative' }}>
      <motion.div 
        animate={{ x: ['-100%', '100%'] }}
        transition={{ duration: 1.5, repeat: Infinity, ease: 'linear' }}
        style={{ 
          position: 'absolute', inset: 0, 
          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.05), transparent)' 
        }}
      />
    </div>
    <div style={{ padding: '1.5rem' }}>
      <div style={{ height: '1.4rem', width: '70%', background: 'rgba(255,255,255,0.05)', borderRadius: '4px', marginBottom: '1rem' }} />
      <div style={{ height: '0.9rem', width: '40%', background: 'rgba(255,255,255,0.05)', borderRadius: '4px', marginBottom: '1.5rem' }} />
      <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.5rem' }}>
         <div style={{ height: '1.5rem', width: '50px', background: 'rgba(255,255,255,0.05)', borderRadius: '6px' }} />
         <div style={{ height: '1.5rem', width: '50px', background: 'rgba(255,255,255,0.05)', borderRadius: '6px' }} />
      </div>
      <div style={{ height: '3rem', width: '100%', background: 'rgba(255,255,255,0.05)', borderRadius: '99rem' }} />
    </div>
  </div>
);

export const SkeletonDashboard = () => (
    <div className="container" style={{ padding: '4rem 0' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '3rem' }}>
        <div>
          <div style={{ height: '3rem', width: '250px', background: 'rgba(255,255,255,0.05)', borderRadius: '8px', marginBottom: '1rem' }} />
          <div style={{ height: '1rem', width: '180px', background: 'rgba(255,255,255,0.05)', borderRadius: '8px' }} />
        </div>
        <div style={{ height: '3rem', width: '120px', background: 'rgba(255,255,255,0.05)', borderRadius: '99rem' }} />
      </div>
      <div style={{ display: 'flex', gap: '2rem' }}>
         <div className="glass" style={{ flex: 1, height: '300px', borderRadius: '1.5rem', padding: '2rem' }}>
            <div style={{ height: '50px', width: '50px', background: 'rgba(255,255,255,0.05)', borderRadius: '12px', marginBottom: '1.5rem' }} />
            <div style={{ height: '1.5rem', width: '60%', background: 'rgba(255,255,255,0.05)', borderRadius: '4px', marginBottom: '1rem' }} />
            <div style={{ height: '4rem', width: '100%', background: 'rgba(255,255,255,0.05)', borderRadius: '4px' }} />
         </div>
         <div className="glass" style={{ flex: 1, height: '300px', borderRadius: '1.5rem', padding: '2rem' }}>
            <div style={{ height: '50px', width: '50px', background: 'rgba(255,255,255,0.05)', borderRadius: '12px', marginBottom: '1.5rem' }} />
            <div style={{ height: '1.5rem', width: '60%', background: 'rgba(255,255,255,0.05)', borderRadius: '4px', marginBottom: '1rem' }} />
            <div style={{ height: '4rem', width: '100%', background: 'rgba(255,255,255,0.05)', borderRadius: '4px' }} />
         </div>
      </div>
    </div>
);
